import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined'
import RedoIcon from '@mui/icons-material/Redo'
import { styled } from '@mui/material/styles'
import { Tooltip, TooltipProps, tooltipClasses } from '@mui/material'
import React, { ReactNode, useCallback } from 'react'
import {
  Container,
  PopupContainer,
  StyledIconButton,
} from './CopyToClipboard.styles'
import { useTheme } from '@mui/material/styles'
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
    padding: 0,
    borderRadius: theme.shape.customBorderRadius.large,
  },
}))

function openWindow(url) {
  window.open(url, '_blank')
  window.focus()
}

const CopyToClipboard = ({
  children,
  text,
  type,
}: {
  children: ReactNode
  text: string
  type?: string
}) => {
  const theme = useTheme()
  const handleCopy = useCallback(
    (e) => {
      e.stopPropagation()
      navigator.clipboard.writeText(text)
    },
    [text],
  )

  const handlePhone = useCallback(
    (e) => {
      e.stopPropagation()
      openWindow(`tel:${text}`)
    },
    [text],
  )

  const handleEmail = useCallback(
    (e) => {
      e.stopPropagation()
      openWindow(`mailto:${text}`)
    },
    [text],
  )

  const handleUrl = useCallback(
    (e) => {
      e.stopPropagation()
      openWindow(text)
    },
    [text],
  )

  return (
    <HtmlTooltip
      disableHoverListener={!text}
      placement="right"
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -70],
            },
          },
        ],
      }}
      title={
        <PopupContainer p={1}>
          {type === 'email' && (
            <StyledIconButton size="small" onClick={handleEmail}>
              <EmailOutlinedIcon
                fontSize="small"
                sx={{ fontSize: 16, color: theme.palette.common.white }}
              />
            </StyledIconButton>
          )}
          {type === 'phone' && (
            <StyledIconButton size="small" onClick={handlePhone}>
              <PhoneOutlinedIcon
                fontSize="small"
                sx={{ fontSize: 16, color: theme.palette.common.white }}
              />
            </StyledIconButton>
          )}
          {type === 'url' && (
            <StyledIconButton size="small" onClick={handleUrl}>
              <RedoIcon
                fontSize="small"
                sx={{ fontSize: 16, color: theme.palette.common.white }}
              />
            </StyledIconButton>
          )}
          <StyledIconButton size="small" onClick={handleCopy}>
            <ContentCopyOutlinedIcon
              fontSize="small"
              sx={{ fontSize: 16, color: theme.palette.common.white }}
            />
          </StyledIconButton>
        </PopupContainer>
      }
    >
      <Container aria-haspopup="true">
        {React.Children.count(children) ? children : text}
      </Container>
    </HtmlTooltip>
  )
}

export default CopyToClipboard
